import { createSelector, createSlice } from "@reduxjs/toolkit";
import { setLocalStorageValue, getLocalStorageValue, setStorageValue, getStorageValue, getCombinedStorageValue } from "@utils/helpers";
import { authApiSlice } from "./authApiSlice";

// const routes = getLocalStorageValue("routes", true);
// const token = getLocalStorageValue("token");
// const users = JSON.parse(localStorage.getItem("users"));
const routes = getCombinedStorageValue("routes", true)
const users = getCombinedStorageValue("users", true);
const token = getStorageValue("token", false, users?.roles[0]);
const verifiedUser = JSON.parse(localStorage.getItem("verifiedUser"));

export const returnAccess = (paramRoutes) => {
  let access = {};
  let checkAccess = paramRoutes || routes || [];
  checkAccess.map((each) => {
    each.admin_routes.map((route) => {
      access[route] = [...(access[route] || []), each.access_type];
    });
  });
  return access;
};

const initialState = {
  token: token ? token : null,
  users: users ? users : null,
  one: {
    email: verifiedUser,
    password: "",
  },
  signUp: {},
  access: returnAccess() || [],
  reloadAccess: [],
  routes: routes?.length ? routes : [],
  stepperLoading: "",
  notifications: [],
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setOneValue: (state, action) => {
      state.one[action.payload.key] = action.payload.value;
    },
    updateInitialState: (state, action) => {
      state.token = action.payload.token;
      state.users = action.payload.data;
      state.access = returnAccess(action.payload.data.routes);
      state.routes = action.payload.data.routes;
      // localStorage.setItem("token", action.payload.token);
      setStorageValue("token", action.payload.token, false, action.payload.data.roles[0]);
      setStorageValue("users", action.payload.data, true, action.payload.data.roles[0]);
      setStorageValue("routes", action.payload.data.routes, true, action.payload.data.roles[0]);

      // localStorage.setItem("users", JSON.stringify(action.payload.data));
      // localStorage.setItem(
      //   "routes",
      //   JSON.stringify(action.payload.data.routes)
      // );

    },
    clearState: (state) => {
      state.token = null;
      state.one = initialState.one;
      state.signUp = initialState.signUp;
      state.users = initialState.users;
    },
    setSignUpValue: (state, action) => {
      state.signUp[action.payload.key] = action.payload.value;
    },
    enqueueSnackbar: (state, action) => {
      state.notifications = [...state.notifications, { ...action.payload }];
    },
    removeSnackbar: (state, action) => {
      state.notifications = state.notifications.filter(
        (each) => each.key !== action.payload
      );
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        authApiSlice.endpoints.loginUser.matchFulfilled,
        (state, action) => {
          state.token = action.payload.token;
          state.users = action.payload.data;
          state.access = returnAccess(action.payload.data.routes);
          state.routes = action.payload.data.routes;
          // setLocalStorageValue("token", action.payload.token);
          // setLocalStorageValue("users", action.payload.data, true);
          // setLocalStorageValue("routes", action.payload.data.routes, true);
          setStorageValue("token", action.payload.token, false, action.payload.data.roles[0]);
          setStorageValue("users", action.payload.data, true, action.payload.data.roles[0]);
          setStorageValue("routes", action.payload.data.routes, true, action.payload.data.roles[0]);
        }
      )
      .addMatcher(
        authApiSlice.endpoints.reloadAccess.matchFulfilled,
        (state, action) => {
          state.access = returnAccess(action.payload.data.routes);
          state.routes = action.payload.data.routes;
          setStorageValue("routes", action.payload.data.routes, true, action.payload.data.roles[0]);
        }
      )
      .addMatcher(
        authApiSlice.endpoints.logoutUser.matchFulfilled,
        (state, { payload }) => {
          state.access = initialState.access;
          state.routes = initialState.routes;
        }
      );
  },
});

export const {
  setOneValue,
  updateInitialState,
  enqueueSnackbar,
  removeSnackbar,
  setSignUpValue,
  clearState,
} = authSlice.actions;

export default authSlice.reducer;

const selectDomain = (state) => state.auth || initialState;

export const makeSelectAccess = createSelector(
  selectDomain,
  (substate) => substate.access
);

export const makeSelectPackageAccess = createSelector(
  selectDomain,
  (substate) => substate.reloadAccess
);

export const makeSelectRoutes = createSelector(
  selectDomain,
  (substate) => substate.routes
);

export const makeSelectUsers = createSelector(
  selectDomain,
  (substate) => substate.users
);

export const makeSelectToken = createSelector(
  selectDomain,
  (substate) => substate.token
);

export const makeSelectOne = createSelector(
  selectDomain,
  (substate) => substate.one
);

export const makeSelectSignUp = createSelector(
  selectDomain,
  (substate) => substate.signUp
);

export const makeSelectStepperLoading = createSelector(
  selectDomain,
  (substate) => substate.stepperLoading
);

export const makeSelectNotifications = createSelector(
  selectDomain,
  (state) => state.notifications
);
